import { createApi } from '../createApi';
import * as dummy from '../dummy/waitlist';
import * as real from '../api/waitlist';

const api = createApi(dummy, real);

export const waitlistService = {
  /* 서비스 (유저용) */
  getList: api.getWaitlist,
  create: api.createWaitlist,
  cancel: api.cancelWaitlist,
  convert: api.convertWaitlist,

  /* 관리자 */
  adminGetList: api.getAdminWaitlist,
  adminNotify: api.notifyAdminWaitlist,
};
